module.exports = __webpack_public_path__ + "static/media/health.5e77a6e9.png";